export default {"src":"/uk/_next/static/media/laptopIcon.3463ee60.svg","height":61,"width":60,"blurWidth":0,"blurHeight":0};